import { Fragment } from "react";
import { Route, RouteProps } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../context-store";
import { Redirect } from "react-router";
import { authActions } from "../../../context-store/auth-context";

interface ProtectedRouteProps extends RouteProps {
    roles?: number[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const authenticated = useAppSelector((state) => state.authState.authenticated);
    const hasRole =
        !props.roles ||
        (loggedInUser && props.roles.includes(Number(loggedInUser.roleId)));

    if (authenticated && !hasRole) {
        dispatch(authActions.logout());
    }

    return (
        <Fragment>
            {authenticated && hasRole &&
                <Route {...props}>{props.children}</Route>}
            {(!authenticated || !hasRole) && <Redirect to="/index"></Redirect>}
        </Fragment>
    );
};
export default ProtectedRoute;